import cx from 'classnames';
import { strollersListUrl } from 'mk2/apps/strollers/urls';
import { ImgCropped, ImgCropMode } from 'mk2/components/ImgCropped';
import { ListItem, ListItemPlaceholder } from 'mk2/components/ListItem';
import { LoadingPlaceholder } from 'mk2/components/LoadingPlaceholder';
import { url } from 'mk2/helpers/urls';
import { StrollerBrandEntity } from 'mk2/schemas';
import React from 'react';
import styles from './BrandListItem.mscss';

interface OwnProps {
    className?: string;
    style?: React.CSSProperties;
    // NOTE: from StrollerBrandEntity - do not use whole interface
    //  define only really needed values. It gives us much more
    //  freedom in tests and stories
    brand: Pick<StrollerBrandEntity, 'strollerPhoto' | 'slug' | 'name'>;
    count: number;
    isLast?: boolean;
}

export const BrandListItem: React.FunctionComponent<OwnProps> = React.memo(({
    brand, count, className, style, isLast,
}) => (
    <ListItem
        style={style}
        className={cx(styles.BrandListItem, className)}
        to={url(strollersListUrl, { slug: brand.slug })}
        icon={
            brand.strollerPhoto && (
                <ImgCropped
                    className={styles.BrandListItem__icon}
                    width={44}
                    height={44}
                    mode={ImgCropMode.Embed}
                    imgWidth={brand.strollerPhoto.originalWidth}
                    imgHeight={brand.strollerPhoto.originalHeight}
                    imgUrl={brand.strollerPhoto.url100x100}
                />
            )
        }
        hasMore
        count={count}
        isLast={isLast}
    >
        <span className={styles.BrandListItem__name}>{brand.name}</span>
    </ListItem>
));

BrandListItem.displayName = 'BrandListItem';

interface PlaceholderOwnProps {
    style?: React.CSSProperties;
    isLast?: boolean;
}

export const BrandListItemPlaceholder: React.FunctionComponent<PlaceholderOwnProps> = ({ style, isLast }) => (
    <ListItemPlaceholder
        style={style}
        icon={<LoadingPlaceholder width={44} height={44} className={styles.BrandListItem__icon} />}
        isLast={isLast}
    />
);

BrandListItemPlaceholder.displayName = 'BrandListItemPlaceholder';
